import { Box, Container, Flex, Grid, Text, Heading } from "@theme-ui/components"
import React from "react"
import { i18nContext } from "../context/i18nContext"
import { InboundLink } from "./link"
import { useCompany } from "../hooks/useCompany"
import { useFooterContent } from "../hooks/useFooterContent"
import { useFooter } from "../hooks/useFooter"
import { useSocial } from "../hooks/useSocial"
import RichContentStructuredText from "./richContentStructuredText"
import { MagicLink } from "../utils/magicLink"
import Linkedin from "../images/linkedin.inline.svg"
import { AiFillFacebook } from "react-icons/ai"
import { AiFillYoutube } from "react-icons/ai"
import AuthButton from "./authButton"

const NewFooter = () => {
  const company = useCompany()
  const content = useFooterContent()
  const footerLinks = useFooter()
  const social = useSocial()
  const iubendaPolicyId = {
    it: "51677540",
    en: "15997033",
    de: "59895348",
  }

  return (
    <i18nContext.Consumer>
      {t => (
        <Box
          as="footer"
          sx={{
            width: "100%",
            maxWidth: "100%",
            borderTop: "1px solid",
            borderColor: "dark",
            paddingTop: "0",
            paddingLeft: "0",
            paddingBottom: "0",
            paddingRight: ["0", "0", "78px"],
          }}
        >
          <Container
            sx={{
              py: [0, 0, 0, 0],
            }}
          >
            <Grid
              columns={["1fr", "1fr 1fr", "1fr 1fr 1fr", "1fr 1fr 1fr"]}
              gap={[0]}
              sx={{
                flexWrap: "wrap",
                alignItems: "space-between",
                justifyContent: "space-between",
              }}
            >
              <Box
                sx={{
                  p: [6],
                  pl: [0, 0, 0],
                  py: [4, 5],
                  borderRight: [
                    "0px solid",
                    "1px solid",
                    "1px solid",
                    "1px solid",
                  ],
                  borderColor: "dark",
                }}
              >
                {company && (
                  <Box sx={{ fontFamily: "roc" }}>
                    <Heading
                      as="div"
                      variant="h3"
                      sx={{
                        mt: [0, 0],
                        mb: [3, 5],
                        color: "dark",
                      }}
                    >
                      {t.contact}
                    </Heading>
                    <Text as="p" sx={{ fontSize: [2, 3] }}>
                      {company.legalName}
                    </Text>
                    <Text as="p" sx={{ fontSize: [2, 3] }}>
                      {company.addresses[0] &&
                        company.addresses[0].streetAddress &&
                        company.addresses[0].streetAddress}
                      {company.addresses[0] &&
                        company.addresses[0].addressLocality &&
                        ", " + company.addresses[0].addressLocality}
                    </Text>
                    <Text as="p" sx={{ fontSize: [2, 3] }}>
                      {company.addresses[0] &&
                        company.addresses[0].postalCode &&
                        company.addresses[0].postalCode + " - "}
                      {company.addresses[0] &&
                        company.addresses[0].addressCountry &&
                        " " + company.addresses[0].addressCountry}
                    </Text>
                    {company.addresses[0] && (
                      <Box
                        as="p"
                        dangerouslySetInnerHTML={{
                          __html: company.addresses[0].email,
                        }}
                        sx={{
                          p: {
                            a: {
                              fontSize: [2, 3],
                              color: "dark",
                            },
                            fontSize: [2, 3],
                          },
                        }}
                      />
                    )}
                  </Box>
                )}
              </Box>
              {social &&
                (social.linkedin || social.facebook || social.youtube) && (
                  <Box
                    sx={{
                      p: [0, 6],
                      py: [4, 5],
                    }}
                  >
                    <Box
                      sx={{
                        mt: [0, 0],
                      }}
                    >
                      <Heading
                        as="div"
                        variant="h3"
                        sx={{
                          mt: [0, 0],
                          mb: [3, 5],
                          color: "dark",
                        }}
                      >
                        {t.followUs}
                      </Heading>
                    </Box>
                    <Flex
                      sx={{
                        flexWrap: "wrap",
                        gap: [3],
                        svg: {
                          width: "30px",
                          fill: "dark",
                        },
                        "a:hover": {
                          svg: {
                            fill: "primary",
                          },
                        },
                        a: {
                          display: "block",
                        },
                      }}
                    >
                      <Box>
                        <MagicLink target="_blank" href={social.linkedin}>
                          <Box sx={{ p: ["4px"] }}>
                            <Linkedin color="#FFF" />
                          </Box>
                        </MagicLink>
                      </Box>
                      <Box>
                        <MagicLink target="_blank" href={social.facebook}>
                          <AiFillFacebook
                            color="#1c1c1c"
                            style={{
                              width: "38px",
                              height: "auto",
                            }}
                          />
                        </MagicLink>
                      </Box>
                      <Box>
                        <MagicLink target="_blank" href={social.youtube}>
                          <AiFillYoutube
                            color="#1c1c1c"
                            style={{
                              width: "38px",
                              height: "auto",
                            }}
                          />
                        </MagicLink>
                      </Box>
                    </Flex>
                  </Box>
                )}

              <Box
                sx={{
                  pr: [0, 6, 6, 0],
                  pl: [0, 0, 6],
                  py: [4, 5],
                  gridColumn: ["1", "1/3", 3, 3],
                  borderLeft: [
                    "0px solid",
                    "0px solid",
                    "1px solid",
                    "1px solid",
                  ],
                  borderColor: "dark",
                  p: {
                    fontSize: [2, 3],
                    fontFamily: "roc",
                  },
                }}
              >
                <Heading
                  as="div"
                  variant="h3"
                  sx={{
                    mt: [0, 0],
                    mb: [3, 5],
                    color: "dark",
                  }}
                >
                  {t.writeUs}
                </Heading>
                <RichContentStructuredText text={content.body} />
              </Box>
            </Grid>
          </Container>
          <Container
            sx={{
              position: "relative",
              color: "dark",
              fontFamily: "heading",
              borderTop: "1px solid",
              borderColor: "dark",
              justifyContent: "space-between",
            }}
          >
            <Grid
              columns={[
                "1fr 1fr",
                "1fr 1fr",
                `repeat(${footerLinks.length},1fr) .5fr`,
              ]}
              sx={{
                flexWrap: "wrap",
                justifyContent: "space-between",
                fontSize: [3, 4, 4, 4],
                fontFamily: "roc",
                paddingY: [3, 4, 4],
                a: {
                  color: "dark",
                  "&:hover": {
                    color: "primary",
                  },
                },
              }}
            >
              {footerLinks.map(
                (item, index) =>
                  item &&
                  item.link && (
                    <Box
                      sx={{
                        minWidth: "150px",
                      }}
                    >
                      <MagicLink
                        sx={{ fontSize: [3, 4] }}
                        item={item.link}
                      />
                    </Box>
                  )
              )}
            </Grid>
          </Container>
          <Container
            sx={{
              position: "relative",
              color: "dark",
              fontFamily: "roc",
              borderTop: "1px solid",
              borderColor: "dark",
              paddingY: [3, 4, 5],
              a: {
                mr: [3],
                color: "dark",
                "&:hover": {
                  color: "primary",
                },
                fontSize: [1, 2],
              },
              p: {
                mr: [3],
              },
            }}
          >
            <Flex>
              <AuthButton />
              <a
                href={`https://www.iubenda.com/privacy-policy/${
                  iubendaPolicyId[t.locale] || iubendaPolicyId["en"]
                }`}
                title="Privacy Policy"
                target="_blank"
              >
                Privacy Policy
              </a>
              <a
                href={`https://www.iubenda.com/privacy-policy/${
                  iubendaPolicyId[t.locale] || iubendaPolicyId["en"]
                }/cookie-policy`}
                title="Cookie Policy"
                target="_blank"
              >
                Cookie Policy
              </a>
              <a
                href="https://segnalazioni.ourwhistleblowing.it/c-matic-spa/segnalazioni/"
                target="_blank"
              >
                Whistleblowing
              </a>
            </Flex>
            {company && (
              <Box sx={{ mt: [4, 6] }}>
                <Text sx={{ fontSize: [0] }}>
                  © {new Date().getFullYear()} {company.legalName} |
                  {company.shareCapital &&
                    " C.S. " + company.shareCapital + "€"}
                  {company.registrationNumber &&
                    "- REA " + company.registrationNumber}
                  {company.addresses[0] &&
                    company.addresses[0].streetAddress &&
                    `- ${t.registeredOffice}: ` +
                      company.addresses[0].streetAddress}
                  {company.addresses[0] &&
                    company.addresses[0].postalCode &&
                    ", " + company.addresses[0].postalCode}
                  {company.addresses[0] &&
                    company.addresses[0].addressLocality &&
                    ", " + company.addresses[0].addressLocality}
                  {company.addresses[0] &&
                    company.addresses[0].addressRegion &&
                    ", " + company.addresses[0].addressRegion}
                  {company.addresses[0] &&
                    company.addresses[0].addressCountry &&
                    " " + company.addresses[0].addressCountry}
                  {", "}
                  {company.vatId && `${t.vat} ${company.vatId}`} - Tutti i
                  Diritti Riservati / All rights reserved
                </Text>
              </Box>
            )}
          </Container>
        </Box>
      )}
    </i18nContext.Consumer>
  )
}

export default NewFooter
